import React, {ReactElement} from "react";
import { Link } from "react-router-dom";

interface NavItemProps {
  icon: ReactElement<any, any>;
  text: string;
  isActive: boolean;
  to: string;
  nested?: boolean;
}

const NavItem: React.FC<NavItemProps> = ({icon, text, isActive, to, nested}) => (
  <li
    id={`Sidebar-${text}`}
    className={`sidebar-item ${isActive ? "active" : ""}`}
    style={{display: "flex", alignItems: "center", height: "40px", paddingLeft: nested ? "2em" : undefined}}
  >
    <Link
      to={to}
      style={{
        display: "flex",
        alignItems: "center",
        textDecoration: "none",
        color: "inherit",
        width: "100%",
        height: "100%",
      }}
    >
      <span style={{display: "inline-flex", alignItems: "center", width: "20px", height: "20px"}}>
        {React.cloneElement(icon, {style: {width: "20px", height: "20px", flexShrink: 0}})}
      </span>
      <span style={{marginLeft: "8px"}}>{text}</span>
    </Link>
  </li>
);

export default NavItem;
